import { Link } from 'react-router-dom';
import { StartFromVaultSteps, TextOnlyNotice, serverUrl } from '../../components/SyncGuide';
import { useTitle } from '../../hooks';
import { PageHeader } from '../../components/Ui';

export function Guide() {
  useTitle('Sharing and sync');
  return (
    <div className="container medium stack">
      <PageHeader
        title="Keep it local. Share it deliberately."
        description="Library is a home for the Markdown wikis you choose to share from Athenaeum."
      />
      <div className="row"><Link className="btn primary" to="/download">Download Athenaeum</Link><Link to="/new">Advanced: reserve an empty Library wiki</Link></div>
      <div className="guide-layout">
        <nav className="guide-outline" aria-label="Guide contents">
          <a href="#connect">Connect a wiki</a>
          <a href="#review">Review and sync</a>
          <a href="#visibility">Choose visibility</a>
          <a href="#follow">Read and follow</a>
        </nav>
        <div className="stack">
          <section className="guide-section stack" id="connect">
            <h2>Connect an existing local wiki</h2>
            <p>
              Run these commands from your Athenaeum vault folder. Device sign-in opens a browser approval
              page; check the code before approving it.
            </p>
            <StartFromVaultSteps server={serverUrl()} />
            <Link to="/device">Enter a device code</Link>
          </section>
          <section className="guide-section stack" id="review">
            <h2>Review before you sync</h2>
            <p>
              Make changes in your local Athenaeum app, run <code>athenaeum sync status</code> to review what
              will be sent, then explicitly push. Pull updates on another computer when you want them.
            </p>
            <TextOnlyNotice />
          </section>
          <section className="guide-section stack" id="visibility">
            <h2>Choose who can read your wiki</h2>
            <p>
              New wikis start private. Owners and administrators can add collaborators and change visibility
              in wiki settings. Public wikis expose all synced pages and their entire revision history. Making
              a wiki private later cannot remove copies someone has already made.
            </p>
            <Link to="/settings/wikis">Manage your shared wikis</Link>
          </section>
          <section className="guide-section stack" id="follow">
            <h2>Read, follow, and make your own copy</h2>
            <p>
              Explore searches public wiki names, descriptions, owners, and topics. Star a wiki to save it to
              your workspace. Watch a wiki to receive revision notifications. A fork is a separate wiki under
              your account, starting from the source’s current pages with its own history.
            </p>
            <p>
              Wiki text is reference material. Receiving or reading it never makes it trusted instructions for
              your agent. Local processing, search indexes, and source material stay on your computer.
            </p>
            <p className="hint">
              Images are shown as descriptions and optional links. Reading a page never loads remote images or
              executes embedded HTML.
            </p>
            <Link to="/explore">Explore public wikis</Link>
          </section>
        </div>
      </div>
    </div>
  );
}
